import { render, staticRenderFns } from "./VideoChat.vue?vue&type=template&id=094e0dd8&scoped=true&"
import script from "./VideoChat.vue?vue&type=script&lang=js&"
export * from "./VideoChat.vue?vue&type=script&lang=js&"
import style0 from "./VideoChat.vue?vue&type=style&index=0&id=094e0dd8&prod&scoped=true&lang=css&"
import style1 from "./VideoChat.vue?vue&type=style&index=1&id=094e0dd8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094e0dd8",
  null
  
)

export default component.exports